import { Component } from '@angular/core';

@Component({
  selector: 'app-indoorinvestments',
  templateUrl: './indoorinvestments.component.html',
  styleUrl: './indoorinvestments.component.scss'
})
export class IndoorinvestmentsComponent {

  items = [
    {
      title: 'وزارة الاتصالات وتكنولوجيا المعلومات',
      files: [
        { name: 'الجهاز القومى لتنظيم الاتصالات', url: 'assets/الجهاز_القومى_لتنظيم_الاتصالات.pdf' },
        { name: 'هيئة تنمية صناعة تكنولوجيا المعلومات', url: 'assets/هيئة تنمية صناعة تكنولوجيا المعلومات.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة البيئة',
      files: [
        { name: 'دليل تقييم التأثير البيئى الخاص بالانشطه الاستثمارية', url: 'assets/دليل تقييم التأثير البيئى الخاص بالانشطه الاستثمارية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة التموين والتجارة الداخلية',
      files: [
        { name: 'دليل وزارة التموين', url: 'assets/دليل وزارة التموين.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة التنمية المحلية',
      files: [
        { name: 'جاري اعداد الدليل', url: '' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الثقافة',
      files: [
        { name: 'دليل وزارة الثقافة', url: 'assets/وزارة الثقافة دليل.pdf' },
        { name: 'المركز القومى للسينما', url: 'assets/المركز القومى للسينما.pdf' },
        { name: 'المصنفات الفنية', url: 'assets/المصنفات الفنية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة البترول والثروة المعدنية',
      files: [
        { name: 'الهيئة المصرية العامة للبترول', url: 'assets/الهيئة المصرية العامة للبترول.pdf' },
        { name: 'جهاز تنظيم انشطة سوق الغاز', url: 'assets/جهاز تنظيم انشطة سوق الغاز.pdf' },
        { name: 'دليل خدمات المستثمرين في صناعة التعدين', url: 'assets/دليل خدمات المستثمرين في صناعة التعدين.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الإسكان',
      files: [
        { name: 'خدمات المواطنين بهيئة المجتمعات العمرانية الجديدة', url: 'assets/خدمات المواطنين بهيئة المجتمعات العمرانية الجديدة.pdf' },
        { name: 'دليل الاتحاد المصرى لمقاولي التشييد والبناء', url: 'assets/دليل الاتحاد المصرى لمقاولي التشييد والبناء.pdf' },
        { name: 'دليل الشركة القابضة لمياه الشرب', url: 'assets/دليل الشركة القابضة لمياه الشرب.pdf' },
        { name: 'دليل الهيئة العامة للتنمية السياحية', url: 'assets/دليل الهيئة العامة للتنمية السياحية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة السياحة والآثار',
      files: [
        { name: 'الاثار', url: 'assets/الاثار.pdf' },
        { name: 'دليل قطاع المنشات الفندقية والسياحية', url: 'assets/دليل قطاع المنشات الفندقية والسياحية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'اتحاد الصناعات المصرية',
      files: [
        { name: 'دليل اتحاد الصناعات المصرية', url: 'assets/دليل اتحاد الصناعات المصرية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الشباب والرياضة',
      files: [
        { name: 'دليل الخدمات الرياضية', url: 'assets/دليل الخدمات الرياضية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الاستثمار والتجارة الخارجية',
      files: [
        { name: 'دليل الرقابة على الصادرات والواردات', url: 'assets/دليل الرقابة على الصادرات والواردات.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'هيئة سلامة الغذاء',
      files: [
        { name: 'دليل ترخيص تداول الغذاء للمحال العامة', url: 'assets/دليل ترخيص تداول الغذاء للمحال العامة.pdf' },
        { name: 'دليل هيئة سلامة الغذاء', url: 'assets/دليل هيئة سلامة الغذاء (1).pdf' }
      ],
      expanded: false,
    },
    {
      title: 'هيئة الدواء المصرية',
      files: [
        { name: 'اجراءات العمل الخاصة بالادارة العامة لتراخيص المصانع', url: 'assets/اجراءات العمل الخاصة بالادارة العامة لتراخيص المصانع.pdf' },
        { name: 'دليل تراخيص المكاتب العلمية', url: 'assets/دليل تراخيص المكاتب العلمية.pdf' },
        { name: 'دليل تراخيص قيد الشركات بسجل شركات التصنيع لدى الغير', url: 'assets/دليل تراخيص قيد الشركات بسجل شركات التصنيع لدى الغير.pdf' },
        { name: 'دليل تراخيص مخازن الادوية والاشتراطات الصحية', url: 'assets/دليل تراخيص مخازن الادوية والاشتراطات الصحية.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الصناعة',
      files: [
        { name: 'دليل الرقابة الصناعية', url: 'assets/دليل الرقابة الصناعية.pdf' },
        { name: 'دليل المواصفات والجودة معتمد', url: 'assets/دليل المواصفات والجودة معتمد.pdf' },
        { name: 'دليل خدمات التنمية الصناعية', url: 'assets/دليل خدمات التنمية الصناعية (1).pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة النقل',
      files: [
        { name: 'النقل البحرى', url: 'assets/النقل البحرى.pdf' },
        { name: 'النقل النهرى', url: 'assets/النقل النهرى.pdf' },
        { name: 'جهاز تنظيم النقل البري الداخلي والدولي', url: 'assets/جهاز تنظيم النقل البري الداخلي والدولي.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الطيران المدني',
      files: [
        { name: 'دليل وزارة الطيران', url: 'assets/دليل وزارة الطيران.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة التربية والتعليم',
      files: [
        { name: 'جاري اعداد الدليل', url: '' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة التعليم العالي والبحث العلمي',
      files: [
        { name: 'ايداع طلب دولى', url: 'assets/ايداع طلب دولى.pdf' },
        { name: 'تسجيل التصميمات التخطيطية', url: 'assets/تسجيل التصميمات التخطيطية.pdf' },
        { name: 'دليل التعليم العالي بعد الاعتماد', url: 'assets/دليل التعليم العالي بعد الاعتماد.pdf' },
        { name: 'منح براءة اختراع', url: 'assets/منح براءة اختراع.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الكهرباء والطاقة المتجددة',
      files: [
        { name: 'جهاز تنظيم مرفق الكهرباء وحماية المستهلك', url: 'assets/جهاز تنظيم مرفق الكهرباء وحماية المستهلك.pdf' },
        { name: 'دليل الشركة المصرية لنقل الكهرباء', url: 'assets/دليل الشركة المصرية لنقل الكهرباء.pdf' },
        { name: 'هيئة تنمية واستخدام الطاقة الجديدة والمتجددة', url: 'assets/هيئة تنمية واستخدام الطاقة الجديدة والمتجددة.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الموارد المائية والري',
      files: [
        { name: 'دليل الموارد المائية والرى', url: 'assets/دليل الموارد المائية والرى.pdf' }
      ],
      expanded: false,
    },
    {
      title: 'وزارة الزراعة واستصلاح الأراضي',
      files: [
        { name: 'الهيئة العامة للخدمات البيطرية', url: 'assets/الهيئة العامة للخدمات البيطرية.pdf' },
        { name: 'دليل الهيئة العامة لتنمية الثروة السمكية', url: 'assets/دليل الهيئة العامة لتنمية الثروة السمكية.pdf' },
        { name: 'دليل قطاع تنميه الثروة الحيوانية والداجنه', url: 'assets/دليل قطاع تنميه الثروة الحيوانية والداجنه.pdf' },
        { name: 'دليل مشروعات التعمير', url: 'assets/دليل مشروعات التعمير.pdf' }
      ],
      expanded: false,
    },
  ];
  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
